import { render, staticRenderFns } from "./VChangePasswordDialog.vue?vue&type=template&id=ab1e6b72"
import script from "./VChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./VChangePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports